import api from "../services/api";
import { offlineDB } from "../offline/db";

/* ================= SYNC FUNCTION ================= */

export const syncOfflineInvoices = async () => {
  const pending = await offlineDB.invoices
    .where("synced")
    .equals(0)
    .toArray();

  if (!pending.length) return;

  for (const invoice of pending) {
    try {
      const payload = {
  items: invoice.items,
  payment_mode: invoice.payment_mode,
  bill_type: invoice.bill_type,

  created_by_user_id: invoice.created_by_user_id,
  created_by_name: invoice.created_by_name,

  customer_mobile: invoice.customer_mobile,
  customer_name: invoice.customer_name
};
  

      const res = await api.post("/pos/invoice", payload);

      await offlineDB.invoices.update(invoice.id, {
        synced: 1,
        sync_status: "SYNCED",
        server_invoice_id: res.data.invoice_id
      });

      console.log("✅ Invoice synced", res.data.invoice_id);

    } catch (err) {
      const msg = err.response?.data?.error || "";

      // 🔥 STOCK NOT READY → WAIT
      if (msg.includes("No stock found")) {
        console.warn(
          "⏸ Invoice waiting for stock",
          invoice.id
        );

        await offlineDB.invoices.update(invoice.id, {
          sync_status: "FAILED_STOCK"
        });

        continue; // ⛔ DO NOT retry now
      }

      console.error("❌ Invoice sync failed", err);
    }
  }
};


